import { render, staticRenderFns } from "./CopMaterialEdit.vue?vue&type=template&id=a8aaca32&scoped=true&"
import script from "./CopMaterialEdit.vue?vue&type=script&lang=js&"
export * from "./CopMaterialEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8aaca32",
  null
  
)

export default component.exports